module.exports = __webpack_public_path__ + "img/emerald_image.fcede146.jpg";